import { lazy } from "react";
import { RouteObject } from "react-router-dom";

const ThankYouPage = lazy(() => import("@/pages/thank-you/page"));
const TourTemplatesPage = lazy(() => import("@/pages/tour-templates/page"));
const RoadtripRoutesPage = lazy(() => import("@/pages/articles/roadtrip-routes/page"));
const CaravanGuidePage = lazy(() => import("@/pages/articles/caravan-guide/page"));
const CaliforniaNevadaItineraryPage = lazy(() => import("@/pages/articles/california-nevada-itinerary/page"));
const NotFound = lazy(() => import("@/pages/NotFound"));

const routes: RouteObject[] = [
  {
    path: "/",
    element: <ThankYouPage />,
  },
  {
    path: "/thank-you",
    element: <ThankYouPage />,
  },
  {
    path: "/tour-templates",
    element: <TourTemplatesPage />,
  },
  {
    path: "/articles/roadtrip-routes",
    element: <RoadtripRoutesPage />,
  },
  {
    path: "/articles/caravan-guide",
    element: <CaravanGuidePage />,
  },
  {
    path: "/articles/california-nevada-itinerary",
    element: <CaliforniaNevadaItineraryPage />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;
